import { apiPost } from "../client";
import type { IExamSet, ExamSetStatus } from "./types";
import { useMutation } from "@tanstack/react-query";

export interface IExamSetCreateRequest {
  exam_type: string;
  title: string;
  description: string;
  status: ExamSetStatus;
  items: { exam_paper_id: string; order: number }[];
}

export const apiCreateExamSet = async (data: IExamSetCreateRequest) => {
  return apiPost<IExamSet>("/exam_sets", data);
};

export const useCreateExamSet = () => {
  return useMutation({
    mutationFn: apiCreateExamSet,
  });
};

export default useCreateExamSet;
